/**
 * @generated SignedSource<<f0ff169002193f536c0a4e7932d85a3c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type MilestoneCreateFormRepositoryQuery$data = {
  readonly nameWithOwner: string;
  readonly viewerCanPush: boolean;
  readonly " $fragmentType": "MilestoneCreateFormRepositoryQuery";
};
export type MilestoneCreateFormRepositoryQuery$key = {
  readonly " $data"?: MilestoneCreateFormRepositoryQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"MilestoneCreateFormRepositoryQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MilestoneCreateFormRepositoryQuery",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nameWithOwner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanPush",
      "storageKey": null
    }
  ],
  "type": "Repository",
  "abstractKey": null
};

(node as any).hash = "0cacdce89acd21e8963249979de7d618";

export default node;
